import { version } from 'process';

import { useQuery } from '@tanstack/react-query';
import uniqBy from 'lodash/uniqBy';

import { useAuthContext } from '@cognite/e2e-auth';
import type { ViewDefinition, ViewReference } from '@cognite/sdk';

import type { QueryMeta } from '../query-client';
import { QueryKeys } from '../../utils/queryKeys';

export const useGetViewsByReferences = (
  viewReferences: Omit<ViewReference, 'type'>[],
  enabled: boolean
) => {
  const { client } = useAuthContext();
  return useQuery<ViewDefinition[] | undefined>({
    queryKey: [QueryKeys.VIEWS, viewReferences],
    queryFn: async () => {
      const { items: views } = await client.views.retrieve(
        uniqBy(
          viewReferences,
          (view) => `${view.externalId}-${view.space}-${version}`
        )
      );
      return views;
    },
    enabled: viewReferences.length > 0 && enabled,
    meta: {
      error: {
        toast: { body: 'Failed to fetch views.' },
      },
    },
  });
};
